import { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.deloitte.radius,
        padding: '18px 34px',
        textTransform: 'none',
        maxHeight: '50px',
        minWidth: '162px',
        fontWeight: 700,
        fontSize: '1 rem'
    },
    main: {
        marginTop: '18px',
        padding: '18px 42px'
    },
    cta: {
        backgroundColor: theme.deloitte.accessible,
        color: theme.palette.common.white,
        '&:hover': {

            backgroundColor: theme.deloitte.hover

        }
    },
    fullWidth: {
        width: '100%'
    }
}));

interface DeloitteButtonProps extends ButtonProps {
    main?: boolean;
    cta?: boolean;
    fullWidth?: boolean;
}

export const DeloitteButton: FC<DeloitteButtonProps> = (props) => {
    const classes = useStyles();
    const { main, cta, fullWidth,
        ...otherProps } = props;
    const selectedClasses = [classes.root, main ? classes.main : null, cta ? classes.cta : null, fullWidth ? classes.fullWidth : null].filter(f => f !== null)
    return <Button {...otherProps} classes={{
        root: clsx(selectedClasses)
    }} />
}
